import React from "react";
import { BUSINESS } from "../lib/constants";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#332C27] bg-[#0f0d0c] pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 rounded-lg overflow-hidden ring-1 ring-[#F5A623]/40">
                <img
                  src={BUSINESS.logo}
                  alt="5-Star Handyman Service"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="font-display text-lg text-[#F9FAFB] font-semibold uppercase tracking-tight">
                  5-Star Handyman Service
                </div>
                <div className="text-[10px] tracking-[0.28em] text-[#F5A623] uppercase">
                  Family-owned · {BUSINESS.city}, {BUSINESS.state}
                </div>
              </div>
            </div>
            <p className="text-[#A19D98] text-sm leading-relaxed max-w-md">
              {BUSINESS.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#F5A623] font-bold mb-4">
              Quick links
            </div>
            <ul className="space-y-2 text-sm">
              {[
                ["Services", "services"],
                ["About", "about"],
                ["Areas Served", "areas"],
                ["Gallery", "gallery"],
                ["Request Quote", "quote"],
                ["FAQ", "faq"],
                ["Contact", "contact"],
              ].map(([label, id]) => (
                <li key={id}>
                  <a
                    href={`#${id}`}
                    data-testid={`footer-link-${id}`}
                    className="text-[#A19D98] hover:text-[#F5A623] transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#F5A623] font-bold mb-4">
              Reach us
            </div>
            <a
              href={`tel:${BUSINESS.phoneRaw}`}
              className="block text-[#F9FAFB] hover:text-[#F5A623] transition-colors font-display text-xl mb-2"
            >
              {BUSINESS.phone}
            </a>
            <a
              href={`mailto:${BUSINESS.email}`}
              className="block text-[#A19D98] hover:text-[#F5A623] transition-colors text-sm"
            >
              {BUSINESS.email}
            </a>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#332C27] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-[#6b645e]">
            © {year} 5-Star Handyman Service. All rights reserved.
          </div>
          <div className="text-xs text-[#6b645e]">
            Proudly serving Lehigh Acres, Fort Myers and Cape Coral, FL.
          </div>
        </div>
      </div>
    </footer>
  );
}
